import { Component, computed, inject, input, LOCALE_ID } from '@angular/core';

@Component({
  selector: 'app-product-information-card',
  imports: [],
  templateUrl: './product-information-card.html',
  styleUrl: './product-information-card.scss',
})
export class ProductInformationCard {
  locale = inject(LOCALE_ID);
  isArabic = computed(() => this.locale.startsWith('ar'));

  category = input();
  subCategory = input();

  mfgCompany = input();
  batchNumber = input();
  description = input();
  mfgDate = input();
  expDate = input();

  pharmacyPrice = input();
  peoplePrice = input();
  businessPriceDiscountPercentage = input();
}
